<template>
    <div
        class="relative flex items-center w-full px-4 py-6 mb-4 bg-white border border-gray-200 shadow-sm rounded-"
    >
        <div
            @click="show = !show"
            class="absolute top-0 flex items-center justify-center w-8 h-8 text-gray-500 cursor-pointer right-1 hover:text-gray-900"
        >
            <svg
                v-show="show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                ></path>
            </svg>
            <svg
                v-show="!show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 15l7-7 7 7"
                ></path>
            </svg>
        </div>
        <div class="w-full px-4 mx-auto sm:px-6 lg:px-8">
            <div class="max-w-4xl mx-auto">
                <div class="flex justify-between" v-show="show">
                    <h2
                        ref="scrollToMe"
                        @click="show = !show"
                        class="text-xl font-extrabold leading-9 text-left text-blue-600 cursor-pointer sm:text-xl sm:leading-10"
                    >
                        {{ name }}
                    </h2>

                    <div @click="removeConstruction">
                        <base-icon
                            width="60"
                            height="60"
                            class="h-8 cursor-pointer"
                            icon-name="trash"
                            viewBox="0 0 20 20 "
                            iconColor="#6C98C6"
                        >
                            <icon-trash />
                        </base-icon>
                    </div>
                </div>
                <div v-show="!show">
                    <tag-group :tags="construction" @clicked="checkBuilding" />

                    <div class="mt-10 ml-3 text-left">
                        <base-image-input
                            v-model="constructionData.image"
                            title="terrain"
                            :id="data.id"
                        />
                        <label
                            v-if="constructionData.buildingType === 'terrain'"
                            for="first_name"
                            class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                            >J'ai un terrain :</label
                        >
                        <toggle
                            v-show="constructionData.buildingType === 'terrain'"
                            :triggered="constructionData.hasField"
                            class="mb-4"
                            v-on:toggleTriggered="hasField"
                        />
                        <br />
                        <base-number-input
                            v-if="constructionData.hasField"
                            label="Prix (HT)"
                            :isCurrency="true"
                            v-model="constructionData.price"
                            :hasError="$v.constructionData.price.$error"
                            :errorMessage="
                                errorMessage('Prix', $v.constructionData.price)
                            "
                            @blur="$v.constructionData.price.$touch()"
                        />
                        <radio-box
                            v-if="!constructionData.hasField"
                            label="Achat"
                            :name="`buyingOrRent ${constructionData.id}`"
                            :value="constructionData.isBuying"
                            @change="changeIsBuying"
                        />
                        <radio-box
                            v-if="!constructionData.hasField"
                            class="ml-6"
                            label="Location"
                            :name="`buyingOrRent ${constructionData.id}`"
                            :value="constructionData.isBuying"
                            @change="changeIsBuying"
                        />
                        <radio-box
                            class="ml-6"
                            label="Leasing"
                            :name="`buyingOrRent ${constructionData.id}`"
                            :value="constructionData.isBuying"
                            v-if="
                                constructionData.buildingType === 'bureaux' &&
                                    !constructionData.hasField &&
                                    !isSimplifiedVersion
                            "
                            @change="changeIsBuying"
                        />
                    </div>
                    <select-menu
                        label="Typologie juridique du terrain "
                        v-if="constructionData.buildingType === 'terrain'"
                        :option="BuildingLegalForm"
                        v-model="constructionData.formJuridique"
                    />
                    <base-input
                        placeholder="Adresse"
                        v-model="constructionData.address"
                        :hasError="$v.constructionData.address.$error"
                        :errorMessage="
                            errorMessage('Adresse', $v.constructionData.address)
                        "
                        @blur="$v.constructionData.address.$touch()"
                    />
                    <base-input
                        v-if="constructionData.buildingType === 'terrain'"
                        placeholder="Numero du titre foncier"
                        v-model="constructionData.landTitle"
                    />
                    <div v-if="!constructionData.hasField">
                        <!-- :hasError="$v.constructionData.address.$error"
              :errorMessage="
                errorMessage('Adresse', $v.constructionData.address)
              "
              @blur="$v.constructionData.address.$touch()" -->
                        <div class="mt-10 ml-3 text-left">
                            <radio-box
                                label="Zone rurale"
                                :name="`terrainLocation ${constructionData.id}`"
                                :value="
                                    constructionData.isRural
                                        ? 'Zone rurale'
                                        : 'Zone urbaine'
                                "
                                @change="changeIsRural"
                            />
                            <radio-box
                                class="ml-6"
                                label="Zone urbaine"
                                :name="`terrainLocation ${constructionData.id}`"
                                :value="
                                    constructionData.isRural
                                        ? 'Zone rurale'
                                        : 'Zone urbaine'
                                "
                                @change="changeIsRural"
                            />
                        </div>
                        <base-number-input
                            label="Superficie (m2)"
                            v-model="constructionData.Superficie"
                            :hasError="$v.constructionData.Superficie.$error"
                            :errorMessage="
                                errorMessage(
                                    'Superficie',
                                    $v.constructionData.Superficie
                                )
                            "
                            @blur="$v.constructionData.Superficie.$touch()"
                        />
                        <base-number-input
                            v-if="
                                constructionData.isBuying === 'Achat' ||
                                    constructionData.isBuying === 'Leasing'
                            "
                            label="Prix/m2 (HT)"
                            v-model="constructionData.price"
                            :isCurrency="true"
                            :hasError="$v.constructionData.price.$error"
                            :errorMessage="
                                errorMessage('Prix', $v.constructionData.price)
                            "
                            @blur="$v.constructionData.price.$touch()"
                        />
                        <base-tips-alert
                            v-if="
                                constructionData.isBuying === 'Leasing' &&
                                    constructionData.buildingType === 'bureaux'
                            "
                            title="Attention"
                            color="bg-orange-100 border-orange-400"
                        >
                            <p class="my-0 mt-1 text-gray-700">
                                Veuillez contacter votre banquier pour avoir la
                                simulation de votre crédit de bail.
                            </p>
                        </base-tips-alert>
                        <base-number-input
                            label="Avance"
                            v-if="
                                constructionData.isBuying === 'Leasing' &&
                                    constructionData.buildingType === 'bureaux'
                            "
                            :isCurrency="true"
                            v-model="constructionData.payedInAdvance"
                            :hasError="
                                $v.constructionData.payedInAdvance.$error
                            "
                            :errorMessage="
                                errorMessage(
                                    'Avance',
                                    $v.constructionData.payedInAdvance
                                )
                            "
                            @blur="$v.constructionData.payedInAdvance.$touch()"
                        />

                        <base-number-input
                            label="Nombre de mois"
                            v-if="
                                constructionData.isBuying === 'Leasing' &&
                                    constructionData.buildingType === 'bureaux'
                            "
                            v-model="constructionData.rentDuration"
                            :hasError="$v.constructionData.rentDuration.$error"
                            :errorMessage="
                                errorMessage(
                                    'Avance en DHs',
                                    $v.constructionData.rentDuration
                                )
                            "
                            @blur="$v.constructionData.rentDuration.$touch()"
                        />

                        <base-number-input
                            v-if="
                                constructionData.isBuying === 'Location' ||
                                    constructionData.isBuying === 'Leasing'
                            "
                            :isCurrency="true"
                            v-model="constructionData.rent"
                            label="Loyer mensuel (HT)"
                            :hasError="$v.constructionData.rent.$error"
                            :errorMessage="
                                errorMessage(
                                    'Loyer mensuel',
                                    $v.constructionData.rent
                                )
                            "
                            @blur="$v.constructionData.rent.$touch()"
                        />

                        <div
                            class="mt-6 mb-6 ml-3 text-left"
                            v-if="
                                constructionData.isBuying === 'Achat' &&
                                    constructionData.buildingType ===
                                        'local_pro'
                            "
                        >
                            <label
                                class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                                >Acquisition Fond de Commerce</label
                            >
                            <radio-box
                                label="oui"
                                :name="`acquisition ${constructionData.id}`"
                                :value="constructionData.FCD ? 'oui' : 'non'"
                                @change="changeAcquisition"
                            />
                            <radio-box
                                class="ml-6"
                                label="non"
                                :name="`acquisition ${constructionData.id}`"
                                :value="constructionData.FCD ? 'oui' : 'non'"
                                @change="changeAcquisition"
                            />
                        </div>
                        <h2
                            class="text-xl font-extrabold leading-9 text-left text-blue-600 sm:text-xl sm:leading-10"
                        >
                            {{ subTitle }}
                        </h2>
                        <div v-if="constructionData.buildingType === 'terrain'">
                            <tag-group
                                :tags="construction_entry"
                                @clicked="checkEntry"
                            />

                            <div
                                v-if="
                                    constructionData.constructionEntry ===
                                        'quantity'
                                "
                            >
                                <cal-input
                                    title="Bâtiment"
                                    class="mt-3"
                                    v-model="
                                        constructionData.constructionCosts
                                            .batiment.price
                                    "
                                    :value2="
                                        constructionData.constructionCosts
                                            .batiment.surface
                                    "
                                    @input2="
                                        payload =>
                                            (constructionData.constructionCosts.batiment.surface = payload)
                                    "
                                    limite="1800 Dh/m²"
                                    :priceError="
                                        $v.constructionData.constructionCosts
                                            .batiment.price
                                    "
                                    :surfaceError="
                                        $v.constructionData.constructionCosts
                                            .batiment.surface
                                    "
                                />
                                <cal-input
                                    title="Charpente"
                                    v-model="
                                        constructionData.constructionCosts
                                            .charpante.price
                                    "
                                    :value2="
                                        constructionData.constructionCosts
                                            .charpante.surface
                                    "
                                    @input2="
                                        payload =>
                                            (constructionData.constructionCosts.charpante.surface = payload)
                                    "
                                    limite="700 Dh/m² - 1000 Dh/m²"
                                    :priceError="
                                        $v.constructionData.constructionCosts
                                            .charpante.price
                                    "
                                    :surfaceError="
                                        $v.constructionData.constructionCosts
                                            .charpante.surface
                                    "
                                />
                                <cal-input
                                    title="Construit en dur"
                                    v-model="
                                        constructionData.constructionCosts
                                            .ConstruitEnDur.price
                                    "
                                    :value2="
                                        constructionData.constructionCosts
                                            .ConstruitEnDur.surface
                                    "
                                    @input2="
                                        payload =>
                                            (constructionData.constructionCosts.ConstruitEnDur.surface = payload)
                                    "
                                    limite="1100 Dh/m² - 1300 Dh/m²"
                                    :priceError="
                                        $v.constructionData.constructionCosts
                                            .ConstruitEnDur.price
                                    "
                                    :surfaceError="
                                        $v.constructionData.constructionCosts
                                            .ConstruitEnDur.surface
                                    "
                                />
                                <cal-input
                                    title="Fondation"
                                    v-model="
                                        constructionData.constructionCosts
                                            .fondation.price
                                    "
                                    :value2="
                                        constructionData.constructionCosts
                                            .fondation.surface
                                    "
                                    @input2="
                                        payload =>
                                            (constructionData.constructionCosts.fondation.surface = payload)
                                    "
                                    limite="400 Dh/m² - 600 Dh/m²"
                                    :priceError="
                                        $v.constructionData.constructionCosts
                                            .fondation.price
                                    "
                                    :surfaceError="
                                        $v.constructionData.constructionCosts
                                            .fondation.surface
                                    "
                                />
                                <cal-input
                                    title="Dallage pour parking"
                                    v-model="
                                        constructionData.constructionCosts
                                            .dallage.price
                                    "
                                    :value2="
                                        constructionData.constructionCosts
                                            .dallage.surface
                                    "
                                    @input2="
                                        payload =>
                                            (constructionData.constructionCosts.dallage.surface = payload)
                                    "
                                    limite="300 Dh/m²"
                                    :priceError="
                                        $v.constructionData.constructionCosts
                                            .dallage.price
                                    "
                                    :surfaceError="
                                        $v.constructionData.constructionCosts
                                            .dallage.surface
                                    "
                                />
                                <cal-input
                                    title="Mur de clôture en dur"
                                    v-model="
                                        constructionData.constructionCosts.mure
                                            .price
                                    "
                                    :value2="
                                        constructionData.constructionCosts.mure
                                            .surface
                                    "
                                    @input2="
                                        payload =>
                                            (constructionData.constructionCosts.mure.surface = payload)
                                    "
                                    limite="400 Dh/(m/l)"
                                    :priceError="
                                        $v.constructionData.constructionCosts
                                            .mure.price
                                    "
                                    :surfaceError="
                                        $v.constructionData.constructionCosts
                                            .mure.surface
                                    "
                                />
                                <div class="flex justify-between">
                                    <h2
                                        class="ml-3 text-lg font-extrabold leading-9 text-left text-blue-600"
                                    >
                                        Total
                                    </h2>
                                    <h2
                                        class="mr-8 text-lg font-extrabold leading-9 text-right text-gray-600"
                                    >
                                        {{ totalConstruction }} DH
                                    </h2>
                                </div>
                            </div>
                            <div
                                v-if="
                                    constructionData.constructionEntry ===
                                        'total'
                                "
                            >
                                <div
                                    class="flex items-center justify-start ml-3"
                                >
                                    <span
                                        class="mt-5 mr-5 text-base font-light leading-9 text-left text-blue-600"
                                        >Total Devis</span
                                    >
                                    <div class="w-56 mx-16 mt-4">
                                        <base-number-input
                                            placeholder="Montant"
                                            :isCurrency="true"
                                            v-model="
                                                constructionData.constructionTotal
                                            "
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            v-if="constructionData.buildingType === 'local_pro'"
                        >
                            <div class="flex items-center justify-start ml-3">
                                <span
                                    class="mt-5 mr-5 text-base font-light leading-9 text-left text-blue-600"
                                    >Total Devis</span
                                >
                                <div class="w-56 mx-16 mt-4">
                                    <base-number-input
                                        :isCurrency="true"
                                        placeholder="Montant"
                                        v-model="
                                            constructionData.constructionTotal
                                        "
                                        :hasError="
                                            $v.constructionData
                                                .constructionTotal.$error
                                        "
                                        :errorMessage="
                                            errorMessage(
                                                'Montant',
                                                $v.constructionData
                                                    .constructionTotal
                                            )
                                        "
                                        @blur="
                                            $v.constructionData.constructionTotal.$touch()
                                        "
                                    />
                                </div>
                            </div>
                        </div>

                        <div v-if="constructionData.buildingType === 'bureaux'">
                            <div class="flex items-center justify-start ml-3">
                                <span
                                    class="mt-5 mr-5 text-base font-light leading-9 text-left text-blue-600"
                                    >Total Devis</span
                                >
                                <div class="w-56 mx-16 mt-4">
                                    <base-number-input
                                        placeholder="Montant"
                                        :isCurrency="true"
                                        v-model="
                                            constructionData.constructionTotal
                                        "
                                        :hasError="
                                            $v.constructionData
                                                .constructionTotal.$error
                                        "
                                        :errorMessage="
                                            errorMessage(
                                                'Montant',
                                                $v.constructionData
                                                    .constructionTotal
                                            )
                                        "
                                        @blur="
                                            $v.constructionData.constructionTotal.$touch()
                                        "
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex justify-end mt-4 ">
                        <base-secondary-button
                            color="red"
                            title="Supprimer"
                            @click="removeConstruction"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RadioBox from "@/components/forms/Toggles/radioBox";
import TagGroup from "@/components/forms/TagGroup";
import IconTrash from "@/components/icons/trash";
import CalInput from "@/components/forms/CalInput";
import Toggle from "@/components/forms/Toggles/simpleToggle";
import SelectMenu from "@/components/forms/select/selectMenu";

import { mapState } from "vuex";

import { supportedImageFile } from "../../../../utils";

import {
    required,
    minLength,
    maxLength,
    integer,
    decimal,
    minValue,
    requiredIf
} from "vuelidate/lib/validators";

import { errorMessage } from "@/mixins/errorMessage.js";
import { mapGetters } from "vuex";
import { scrollToRef } from "@/mixins/scrollToMixin.js";

export default {
    components: { CalInput, RadioBox, TagGroup, IconTrash, Toggle, SelectMenu },
    props: {
        data: {
            type: Object
        },

        title: {
            type: String
        }
    },

    mixins: [errorMessage, scrollToRef],

    validations() {
        return { ...this.fieldTypeValidators };
    },
    mounted() {
        this.construction.forEach(elem => {
            if (elem.value === this.constructionData.buildingType)
                elem.isActive = true;
        });
    },
    created() {
        this.construction = [
            { name: "Terrain", value: "terrain", isActive: false },
            {
                name: "Local commercial",
                value: "local_pro",
                isActive: false
            },
            {
                name: "Plateaux de bureaux",
                value: "bureaux",
                isActive: false
            }
        ];
    },
    data() {
        return {
            tags2: [
                { name: "Achats en propriété", value: "achat", isActive: true },
                { name: "Achats en leasing", value: "leasing", isActive: false }
            ],
            constructionData: this.data,
            show: false,
            acquisition: true,
            name: "Moyens fonciers et immeubles",
            construction: [],
            construction_entry: [
                {
                    name: "Saisie detaillée",
                    value: "quantity",
                    isActive: true
                },
                {
                    name: "Saisie du montant global",
                    value: "total",
                    isActive: false
                }
            ]
        };
    },
    methods: {
        hasField(e) {
            this.$set(this.constructionData, "hasField", e);
        },
        changeIsBuyingType(newValue) {
            this.constructionData.hasLeasing =
                newValue === "achat" ? true : false;
        },
        checkEntry(e) {
            this.constructionData.constructionEntry = e;
        },
        checkBuilding(e) {
            this.constructionData.buildingType = e;
            this.constructionData.hasField = false;
        },
        changeIsBuying(newValue) {
            this.constructionData.isBuying = newValue;
        },
        changeAcquisition(newValue) {
            this.constructionData.FCD = newValue === "oui" ? true : false;
        },
        changeIsRural(newValue) {
            this.constructionData.isRural =
                newValue === "Zone rurale" ? true : false;
        },

        createConstruction() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$store.dispatch(
                    "EtudeTechnique/createConstruction",
                    this.constructionData
                );
                this.show = true;
                return true;
            } else {
                this.show = false;
                return false;
            }
        },
        removeConstruction() {
            this.$emit("remove", this.constructionData.id);
        }
    },
    computed: {
        ...mapGetters("user", {
            isSimplifiedVersion: "isSimplifiedVersion"
        }),
        ...mapState("forms", {
            BuildingLegalForm: state => state.BuildingLegalForm
        }),
        subTitle() {
            return this.constructionData.buildingType === "terrain"
                ? "Construction"
                : "Aménagement (HT)";
        },
        totalConstruction() {
            return Object.values(
                this.constructionData.constructionCosts
            ).reduce((a, b) => {
                if (b.price === null || b.surface === null) return a;
                return a + parseInt(b.price) * parseInt(b.surface);
            }, 0);
        },
        fieldTypeValidators() {
            if (this.constructionData.hasField) {
                return {
                    image: { supportedImageFile },
                    constructionData: {
                        price: { required, decimal, minValue: minValue(0) },
                        address: {
                            minLength: minLength(3),
                            maxLength: maxLength(150)
                        }
                    }
                };
            }
            if (
                this.constructionData.isBuying === "Achat" &&
                !this.constructionData.hasField
            ) {
                return {
                    image: { supportedImageFile },
                    constructionData: {
                        price: { required, decimal, minValue: minValue(0) },
                        address: {
                            minLength: minLength(3),
                            maxLength: maxLength(150)
                        },
                        Superficie: {
                            required,
                            decimal,
                            minValue: minValue(0)
                        },
                        constructionCosts: {
                            batiment: {
                                surface: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.batiment
                                                .price !== null &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.batiment
                                                    .price
                                            ) &&
                                            this.constructionData
                                                .constructionCosts.batiment
                                                .price !== 0
                                        )
                                            return true;
                                        return false;
                                    })
                                },
                                price: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.batiment
                                                .surface !== null &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.batiment
                                                    .surface
                                            ) &&
                                            this.constructionData
                                                .constructionCosts.batiment
                                                .surface !== 0
                                        )
                                            return true;
                                        return false;
                                    })
                                }
                            },
                            charpante: {
                                surface: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.charpante
                                                .price !== null &&
                                            this.constructionData
                                                .constructionCosts.charpante
                                                .price !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.charpante
                                                    .price
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                },
                                price: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.charpante
                                                .surface !== null &&
                                            this.constructionData
                                                .constructionCosts.charpante
                                                .surface !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.charpante
                                                    .surface
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                }
                            },
                            ConstruitEnDur: {
                                surface: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts
                                                .ConstruitEnDur.price !==
                                                null &&
                                            this.constructionData
                                                .constructionCosts
                                                .ConstruitEnDur.price !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts
                                                    .ConstruitEnDur.price
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                },
                                price: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts
                                                .ConstruitEnDur.surface !==
                                                null &&
                                            this.constructionData
                                                .constructionCosts
                                                .ConstruitEnDur.surface !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts
                                                    .ConstruitEnDur.surface
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                }
                            },
                            fondation: {
                                surface: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.fondation
                                                .price !== null &&
                                            this.constructionData
                                                .constructionCosts.fondation
                                                .price !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.fondation
                                                    .price
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                },
                                price: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.fondation
                                                .surface !== null &&
                                            this.constructionData
                                                .constructionCosts.fondation
                                                .surface !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.fondation
                                                    .surface
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                }
                            },
                            dallage: {
                                surface: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.dallage
                                                .price !== null &&
                                            this.constructionData
                                                .constructionCosts.dallage
                                                .price !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.dallage
                                                    .price
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                },
                                price: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.dallage
                                                .surface !== null &&
                                            this.constructionData
                                                .constructionCosts.dallage
                                                .surface !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.dallage
                                                    .surface
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                }
                            },
                            mure: {
                                surface: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.mure
                                                .price !== null &&
                                            this.constructionData
                                                .constructionCosts.mure
                                                .price !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.mure
                                                    .price
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                },
                                price: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.mure
                                                .surface !== null &&
                                            this.constructionData
                                                .constructionCosts.mure
                                                .surface !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.mure
                                                    .surface
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                }
                            }
                        },
                        constructionTotal: { decimal, minValue: minValue(0) }
                    }
                };
            } else if (
                this.constructionData.isBuying === "Location" &&
                !this.constructionData.hasField
            ) {
                return {
                    image: { supportedImageFile },
                    constructionData: {
                        rent: { required, decimal, minValue: minValue(0) },
                        address: {
                            minLength: minLength(3),
                            maxLength: maxLength(150)
                        },
                        constructionCosts: {
                            batiment: {
                                surface: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.batiment
                                                .price !== null &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.batiment
                                                    .price
                                            ) &&
                                            this.constructionData
                                                .constructionCosts.batiment
                                                .price !== 0
                                        )
                                            return true;
                                        return false;
                                    })
                                },
                                price: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.batiment
                                                .surface !== null &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.batiment
                                                    .surface
                                            ) &&
                                            this.constructionData
                                                .constructionCosts.batiment
                                                .surface !== 0
                                        )
                                            return true;
                                        return false;
                                    })
                                }
                            },
                            charpante: {
                                surface: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.charpante
                                                .price !== null &&
                                            this.constructionData
                                                .constructionCosts.charpante
                                                .price !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.charpante
                                                    .price
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                },
                                price: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.charpante
                                                .surface !== null &&
                                            this.constructionData
                                                .constructionCosts.charpante
                                                .surface !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.charpante
                                                    .surface
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                }
                            },
                            ConstruitEnDur: {
                                surface: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts
                                                .ConstruitEnDur.price !==
                                                null &&
                                            this.constructionData
                                                .constructionCosts
                                                .ConstruitEnDur.price !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts
                                                    .ConstruitEnDur.price
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                },
                                price: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts
                                                .ConstruitEnDur.surface !==
                                                null &&
                                            this.constructionData
                                                .constructionCosts
                                                .ConstruitEnDur.surface !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts
                                                    .ConstruitEnDur.surface
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                }
                            },
                            fondation: {
                                surface: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.fondation
                                                .price !== null &&
                                            this.constructionData
                                                .constructionCosts.fondation
                                                .price !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.fondation
                                                    .price
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                },
                                price: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.fondation
                                                .surface !== null &&
                                            this.constructionData
                                                .constructionCosts.fondation
                                                .surface !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.fondation
                                                    .surface
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                }
                            },
                            dallage: {
                                surface: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.dallage
                                                .price !== null &&
                                            this.constructionData
                                                .constructionCosts.dallage
                                                .price !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.dallage
                                                    .price
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                },
                                price: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.dallage
                                                .surface !== null &&
                                            this.constructionData
                                                .constructionCosts.dallage
                                                .surface !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.dallage
                                                    .surface
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                }
                            },
                            mure: {
                                surface: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.mure
                                                .price !== null &&
                                            this.constructionData
                                                .constructionCosts.mure
                                                .price !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.mure
                                                    .price
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                },
                                price: {
                                    required: requiredIf(function() {
                                        if (
                                            this.constructionData
                                                .constructionCosts.mure
                                                .surface !== null &&
                                            this.constructionData
                                                .constructionCosts.mure
                                                .surface !== 0 &&
                                            !isNaN(
                                                this.constructionData
                                                    .constructionCosts.mure
                                                    .surface
                                            )
                                        )
                                            return true;
                                        return false;
                                    })
                                }
                            }
                        },
                        Superficie: {
                            required,
                            decimal,
                            minValue: minValue(0)
                        },
                        amenagment: { decimal, minValue: minValue(0) },
                        constructionTotal: { decimal, minValue: minValue(0) }
                    }
                };
            } else {
                return {
                    image: { supportedImageFile },
                    constructionData: {
                        rent: { required, decimal, minValue: minValue(0) },
                        price: { required, decimal, minValue: minValue(0) },
                        address: {
                            minLength: minLength(3),
                            maxLength: maxLength(150)
                        },
                        Superficie: {
                            required,
                            decimal,
                            minValue: minValue(0)
                        },
                        amenagment: { decimal, minValue: minValue(0) },
                        constructionTotal: { decimal, minValue: minValue(0) },

                        rentDuration: {
                            required,
                            integer,
                            minValue: minValue(0)
                        },
                        payedInAdvance: {
                            required,
                            decimal,
                            minValue: minValue(0)
                        }
                    }
                };
            }
        }
    }
};
</script>
<style></style>
